import { HttpMethod, RequestOptions, useUserOrKioskRequest } from "../../common/lib/fetch";

const useReceivingToManualDelivery = (stagedPurchaseOrderId: string, options: RequestOptions) =>
  useUserOrKioskRequest<void>({
    method: HttpMethod.POST,
    path: `/api/stagedPurchaseOrders/${stagedPurchaseOrderId}/toManualDelivery`
  }, options);

export default useReceivingToManualDelivery;
